module.exports = __webpack_public_path__ + "img/20-5.1b16e3c9.png";